/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.26",
    versionName: "0.2.0-nightly.2025.12.26",
    versionChannel: "nightly",
    buildDate: "2025-12-26T00:07:51.386Z",
    commitHash: "7b857d6ccdba1a11abe6e051e029055ef551b622",
};
